module.exports = {
  isHeadwayTail: ' 头程尾程',
  containerLoadType: ' 委托类型',
  transportType: ' 运输类型',
  fullHalf: ' 全程/半程',
  transportLine: ' 航线',
  ETD: ' 发运日期',
  ETA: ' 到达日期',
  ATD: ' 实际发运日期',
  ETD2: ' 发运日期(ETD)',
  ETA2: ' 到达日期(ETA)',
  ATD2: ' 实际发运日期(ATD)',
  ATA2: ' 实际到达日期(ATA)',
  departureStation: ' 始发站',
  departureStationRe: '始发站(铁路)',
  transferStation: ' 中转站',
  transitStation: ' 过境站',
  destinationStation: ' 目的站',
  destinationStationRe: '目的站(铁路)',
  destinationCountry: ' 目的国',
  portAgent: ' 口岸代理',
  forwardingAgent: ' 发运代理',
  paymentMethod: ' 付款方式',
  mbl: ' 运单号',
  vessel: ' 班车',
  voyageFlight: ' 车次',
  isDiffPlacesCollaborate: ' 异地协同',
  loadingPlaceCompany: ' 装货地公司',
  signBillPlaceCompany: ' 签单地公司',
  isFullShipment: ' 全程出运',
  dischargePortCompany: ' 卸货港公司',
  destinationPortCompany: ' 目的港公司',
  overseaOp: ' 国外客服',
  planner: ' 路线负责人',
  plannerOffice: '路线公司',
  plannerDepartment: '路线部门',
  batchVessel: ' 批量转车',

  Query: ' 查询',
  BuyContainer: ' 买箱',
  CallContainer: '调箱',
  SellContainer: ' 卖箱',
  RentContainer: ' 租箱',
  ClearContainerLog: '清除调箱记录',
  ReturnBox: '还箱',
  Edit: ' 编辑',
  Delete: ' 删除',
  OrderNo: ' 订单号',
  OrderNo2: '订单编号',
  JobNo2: '业务编号',
  ConsignationCompany: '委托客户',
  BoxOwner: '箱主/卖家',
  BoxOwner3: '箱主',
  BoxOwner2: '卖方',
  Buyer2: '买方',
  Buyer: '买家',
  OrderType: ' 订单类型',
  ContainerStatus: ' 箱子状态',
  ContainerType: '箱子类型',
  Amount: ' 金额',
  WhetherSettlement: ' 是否结算',
  SettlingTime: ' 结算日期',
  BuyerTime: ' 买箱日期',
  SellTime: ' 卖箱日期',
  ReturnTime: ' 退还日期',
  OperationTime: ' 操作日期',
  Prompt1: '请输入订单号',
  Prompt2: '请输入箱号',
  QuantitySum: '总箱量',
  AmountSum: '总金额',
  Quantity2: '数量',
  BuyTime: '购买日期',
  SellerDate: '出售日期',
  RentDate: '起租日期',
  StartRentDate: '起租日期',
  ReturnDate: '结束日期',
  UnitRate: '单价',
  ContainerNo: '箱号',
  CurrencyCode: '币种',
  EQSize: '箱型',
  EQType: '箱种',
  EQQuantity: '箱数',
  Add: '新增',
  Confirm: '确认',
  Cancel: '取消',
  Operation: '操作',
  UnitRate2: '单价（RMB/天）',
  UnitRate3: 'RMB/天',
  ReturnBoxDate: '还箱时间',
  Term: '期限',
  Day: '天',
  UnitPriceInterval: '单价区间',
  BuyBoxTotalTankVolume: '购箱总箱量',
  TotalCost: '成本总金额',
  SellOutTotalTankVolume: '卖出总箱量',
  TotalSalesAmount: '卖出总金额',
  CostUnitPrice: '成本单价',
  CostUnitPriceCurrencyCode: '成本单价币种',
  SellingUnitPrice: '卖出单价',
  SellingUnitPriceCurrencyCode: '卖出单价币种',
  ETDNotNull: '发运日期不能为空',
  ETANotNull: '到达日期不能为空',
  PaymentMethodCannotBlank: '付款方式不能为空',
  DepartureStationCannotEmpty: '始发站不能为空',
  TransferStationCannotEmpty: '中转站不能为空',
  TransitStationCannotEmpty: '过境站不能为空',
  DestinationStationCannotEmpty: '目的站不能为空',
  CharacterLengthTooLongMaintainAgain: '字符长度超长，请重新维护！',
  TheNotOnTheBustrain: '所选单据不是同一个班车/车次',
  OperationFailed: '操作失败',
  SelectTime: '选择时间',
  BulkModifyDestinationPortInformation: '批量修改目的港信息',
  NonWarehouseOverseasTransferWarehouse: '海外中转仓非亚马逊仓',
  EstimatedDeliveryTime: '预计送达时间',
  ActualDeliveryTime: '实际送达时间',
  DomesticWarehouse: '国内仓',
  OverseasWarehouse: '国外仓',
  WithCostRefundForClearing: '（有费用退关）',
  TheExpiresAndNoCreated: '该委托单位合同到期，不能再创建业务',
  DueNotBePrintedNeeded: '由于信控超出,本票已被锁定,将不能打印或者EDI,请需要时联系上级解锁!',
  LockedPleaseContactTheUnlock: '已被锁定,不能打印,请联系上级主管解锁!',
  FCLProfitPrint: '整箱利润打印',
  AttachmentContentTooLarge: '附件内容过大',
  LCLProfitPrint: '拼箱利润打印',
  ContainerType2: '箱种',
  AdjustmentOperation: '调箱操作',
  All: '全部',
  Days: '天',
  ExpectedToEnterAmazonWarehouse: '预期入亚马逊仓时间',
  ReferenceContainerNumber: '参考箱号',
  Export: '出口',
  Import: '进口',
  ReturnContainer: '还箱',
  PleaseEnterContainerInformation: '请输入箱子信息！',
  PleaseEnterReturnContainerTime: '请输入还箱时间！',
  ReturnSuccessfulSuccessfulReturnCount: '还箱操作成功！成功还箱数：',
  NumberOfContainerPieces: '箱量件数:',
  GreaterActualNumberOfPieces: '大于实际件数:',
  ContainerWeight: '箱量重量:',
  GreaterThanTheActualWeight: '大于实际重量:',
  ContainerVolume: '箱量体积:',
  GreaterThanTheActualVolume: '大于实际体积:',
  JobNumber: '工作号:',
  ServiceChannel: '服务渠道',
  PostalCode: '邮编',
  DestinationDeliveryMethod: '目的地配送方式',
  ExpressCompany: '快递公司',
  TrackingNumber: '快递单号',
  POoriginalOrderNumber: 'PO(原单号)',
  CustomsDeclarationMethod: '报关方式',
  CustomsClearanceMethod: '清关方式',
  EORIEnterpriseNumber: 'EORI企业号',
  VATtaxNumber: 'VAT/税号',
  VATRegistrationCountry: 'VAT注册国家',
  VATRegistrationAddress: 'VAT注册地址',
  VATCompanyEnglishName: 'VAT公司英文名',
  WithBattery: '带电',
  WithMagnet: '带磁',
  Powder: '粉末',
  Liquid: '液体',
  EstimatedStoragegoodsReadyTime: '预计入库/货好时间',
  RemoteWarehouse: '偏远仓',
  ThisHasExpiredCannotBusiness: '该委托单位合同到期，不能再创建业务',
  Freight: '运费',
  ServiceChannel2: '服务渠道：',
  CostType: '费用类型：',
  EstimatedAmount: '预估金额：',
  EquivalentTo: '折合',
  FareLevel: '运价级别：',
  BillingWeight: '计费重量：',
  CalculationMethod: '计算方式：',
  TheTypeCannotBeEmpty: '委托类型不能为空',
  TransportTypeCannotBeEmpty: '运输类型不能为空',
  FullJourneyCannotBeEmpty: '全程/半程不能为空',
  ShippingRouteCannotBeEmpty: '航线不能为空',
  DepartureBeLaterThanDate: '发运日期不能晚于到达日期',
  DepartureStationCannotBeEmpty: '始发站不能为空',
  TransitStationCannotBeEmpty: '中转站不能为空',
  TransitStationCannotBeEmpty2: '过境站不能为空',
  DestinationStationCannotBeEmpty: '目的站不能为空',
  PaymentMethodCannotBeEmpty: '付款方式不能为空',
  SalesCannotBeEmpty: '销售不能为空',
  OperationCannotBeEmpty: '操作不能为空',
  AlreadyOtherBoxTypesTime: '已经选择了[敞车/棚车/平车]，不能同时选择这三种箱种外的箱种!',
  EstimatedTimeCannotBeEmpty: '预计入仓/货好时间不能为空！',
  DestinationCannotBeEmpty: '目的地不能为空！',
  DestinationCountryCannotBeEmpty: '目的国不能为空！',
  ZipCodeCannotBeEmpty: '邮编不能为空！',
  CannotBeEmpty: '不能为空！',
  PleaseTheEntrustingUnitFirst: '请先选择委托单位。',
  EstimatedStoragegoodReadyTime: '预计入库/货好时间',
  NoTicketChecked: '未勾选小票',
  CustomersOwnContainer: '客户自备箱',
  CompanyOwnedContainer: '公司自有箱',
  RentalContainer: '外租箱',
  ContainerUsageImportTemplateRailwayXls: 'ContainerUsageImportTemplate(铁路).xls',
  CurrentBeenSubmittedCannotOperate: '当前业务已提交，不能操作！',
  AreWantToPerformOperation: '确定执行此操作吗？',
  CostNotConfiguredPleaseCheck: '费用类型未配置,请检查！',
  CostAuditedOrInvoicedCheck: '费用已审核或已开发票，请检查！',
  CleaningCompletedSuccessfulCleaningNumber: '清理完成！成功清理数量：',
  PleaseBoxesYouWantProcess: '请勾选需要处理的箱子！',
  ContainsContainerDataPleaseCheck: '包含未调箱数据，请检查！',
  PleaseSelectAContainer: '请选中一个箱子',
  FirstLeglastLeg: '头程/尾程',
  TransportationMethod: '运输方式',
  ContactPerson: '联系人',
  DetailedAddress: '详细地址',
  FirstLeglastLegInformation: '头程/尾程信息',
  CustomerDoordestinationPortDoor: '客户门点/目的港门点',
  CustomerContactPerson: '客户联系人',
  FirstLegCannotBeEmpty: '头程/尾程不能为空',
  PleaseEnterTransportationCompanyInformation: '请输入运输公司信息',
  PleaseSelectDesignatedData: '请选择指定数据',
  PleaseSelectTradeInformation: '请选择贸易信息.',
  RailwayOperationGoodsDetails: '铁路操作货物明细',
  SellingContainer: '卖箱',
  TotalPurchaseContainer: '购箱总箱量',
  TotalCostAmount: '成本总金额',
  TotalSoldContainer: '卖出总箱量',
  TotalSellingAmount: '卖出总金额',
  ModificationSuccessful: '修改成功',
  BuyingContainer: '买箱',
  Yes: '是',
  No: '否',
  PleaseTheContainerToEdit: '请选择要编辑的箱子！',
  EditOrderInformation: '编辑订单信息',
  PleaseTheContainerToDelete: '请选择要删除的箱子！',
  AreWantToDeleteInformation: '确定删除该箱子信息？',
  PromptInformation: '提示信息',
  DeletingOrderContainsOccupiedContainers: '删除订单中包含已占用箱子！',
  CurrentlySelected: '(当前选择)',
  CurrentPage: '(当前页)',
  CurrentlyAvailable: '当前可用',
  CurrentlyOccupied: '当前占用',
  Sold: '已卖',
  ContainerInquiry: '集装箱查询',
  BoxReturnedCannotContinueOperate: '箱号为：{0}，已还箱，不能继续操作！'
}
